import REST from '../REST';
import normalize from './normalize';

export const load = ({ all }) => {
  let url = '/privacy_policies';
  if (all) { url = `${url}?all=true`; }
  const options = {
    vendorId: process.env.REACT_APP_PTE_ID,
    header: {
      'Cache-Control': 'no-cache',
    },
  };
  return REST.get(url, options).then(normalize);
};

export const update = (version) => (
  REST
    .put('/users/term_version', {
      body: { term_version: version },
    })
);



// WEBPACK FOOTER //
// ../src/resources/terms/index.js